import type { SeccionCobrador } from './cobrador-service';
import type { QueryCobradorCerca } from './cobrador-service';

export const cobradorKeys = {
  all: ['cobrador'] as const,
  dashboard: () => [...cobradorKeys.all, 'dashboard'] as const,
  clienteContext: (idCliente: number) =>
    [...cobradorKeys.all, 'cliente-context', idCliente] as const,
  // La key incluye la sección + paginación; invalidar solo por sección (prefijo)
  // refresca todas las páginas de esa pestaña.
  clientes: (seccion: SeccionCobrador, params?: Record<string, unknown>) =>
    [...cobradorKeys.all, 'clientes', seccion, params] as const,
  // Tab Cerca: posición (snapshot) + radio. Un cambio de posición o de radio
  // genera otra key y por tanto otro fetch; `null` = aún sin ubicación.
  cerca: (ubicacion: QueryCobradorCerca | null) =>
    [...cobradorKeys.all, 'cerca', ubicacion] as const,
};
